module.exports = __webpack_public_path__ + "static/pic04-56ffd4f5bd9426bef7ccf55a03830374.jpg";